import React from 'react';
import { priorityConfig, statusConfig } from './taskConstants';

function TaskItem({ task, onToggle, onEdit, onDelete }) {
  const isCompleted = task.status === 'zakonczone';
  const isOverdue = task.termin_wykonania && new Date(task.termin_wykonania) < new Date() && !isCompleted;
  const priority = priorityConfig[task.priorytet] || priorityConfig.normalny;
  const status = statusConfig[task.status] || statusConfig.nowe;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      padding: '10px 12px',
      backgroundColor: isOverdue ? 'var(--danger-light)' : 'var(--card-bg)' ,
      borderRadius: '6px',
      border: `1px solid ${isOverdue ? 'var(--danger-light)' : 'var(--border)'}`,
      marginBottom: '6px',
      opacity: isCompleted ? 0.7 : 1,
      transition: 'all 0.2s'
    }}>
      {/* Status toggle */}
      <button
        onClick={() => onToggle(task.id)}
        style={{
          width: '28px',
          height: '28px',
          background: status.bg,
          border: `1px solid ${status.color}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '14px',
          cursor: 'pointer',
          flexShrink: 0
        }}
        title={status.label}
      >
        {status.icon}
      </button>

      {/* Priority indicator */}
      <div style={{
        width: '4px',
        height: '28px',
        borderRadius: '2px',
        backgroundColor: priority.text,
        flexShrink: 0
      }} />

      {/* Task content */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
          <span style={{
            fontWeight: 500,
            fontSize: '13px',
            color: isCompleted ? 'var(--text-muted)' : 'var(--text)',
            textDecoration: isCompleted ? 'line-through' : 'none'
          }}>
            {task.tytul}
          </span>
          {task.grupa_nazwa && (
            <span style={{
              padding: '1px 6px',
              fontSize: '10px',
              borderRadius: '3px',
              backgroundColor: task.grupa_kolor + '20',
              color: task.grupa_kolor,
              fontWeight: 500
            }}>
              {task.grupa_nazwa}
            </span>
          )}
          {task.subtask_count > 0 && (
            <span style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
              ({task.completed_subtask_count}/{task.subtask_count})
            </span>
          )}
        </div>
        {task.opis && (
          <p style={{
            fontSize: '11px',
            color: 'var(--text-muted)',
            margin: '2px 0 0',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {task.opis}
          </p>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '3px' }}>
          {task.termin_wykonania && (
            <span style={{
              fontSize: '10px',
              color: isOverdue ? 'var(--danger)' : 'var(--text-muted)',
              fontWeight: isOverdue ? 600 : 400
            }}>
              {'📅'} {new Date(task.termin_wykonania).toLocaleDateString('pl-PL')}
            </span>
          )}
          {task.location_nazwa && (
            <span style={{ fontSize: '10px', color: 'var(--info)' }}>
              {'📍'} {task.location_nazwa}
            </span>
          )}
          {task.przypisany_do && (
            <span style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
              {'👤'} {task.przypisany_do}
            </span>
          )}
          {task.is_private === 1 && (
            <span style={{ fontSize: '10px', color: 'var(--purple)' }}>
              {'🔒'} Prywatne
            </span>
          )}
        </div>
      </div>

      {/* Priority badge */}
      <span style={{
        padding: '3px 8px',
        fontSize: '10px',
        fontWeight: 500,
        borderRadius: '3px',
        backgroundColor: priority.bg,
        color: priority.text,
        border: `1px solid ${priority.border || priority.text}`,
        flexShrink: 0
      }}>
        {priorityConfig[task.priorytet]?.label?.split(' ')[1] || 'Normalny'}
      </span>

      {/* Actions */}
      <div style={{ display: 'flex', gap: '3px', flexShrink: 0 }}>
        <button
          onClick={() => onEdit(task)}
          style={{
            padding: '4px 10px',
            background: 'var(--bg)',
            border: '1px solid var(--border)',
            fontSize: '12px'
          }}
          title="Edytuj"
        >
          {'✏️'}
        </button>
        <button
          onClick={() => onDelete(task.id)}
          style={{
            padding: '4px 10px',
            background: 'var(--bg)',
            border: '1px solid var(--border)',
            fontSize: '12px'
          }}
          title="Usuń"
        >
          {'🗑️'}
        </button>
      </div>
    </div>
  );
}

export default React.memo(TaskItem);
